module.exports = __webpack_public_path__ + "img/AT.0c4f155b.svg";